import MenuToggle from './components/menu-toggle';
import SubmenuToggle from './components/submenu-toggle';

class Header {
  constructor(options = {}) {
    this.config = {
      module: document.querySelector('[data-module="Header"]'),
      menuToggle: new MenuToggle(options),
      submenuToggle: new SubmenuToggle(options),
      ...options
    };
  }

  init() {
    const { module, menuToggle, submenuToggle } = this.config;

    if (!module) {
      return;
    }

    menuToggle.init();
    submenuToggle.init();

    this.disableTransitions();

    window.addEventListener('resize', this.disableTransitions.bind(this));
  }

  destroy() {
    const { menuToggle, submenuToggle } = this.config;

    menuToggle.destroy();
    submenuToggle.destroy();

    this.disableTransitions();

    window.removeEventListener('resize', this.disableTransitions.bind(this));
  }

  disableTransitions() {
    const { module } = this.config;

    module.classList.add('no-transition');
    setTimeout(() => module.classList.remove('no-transition'));
  }
}

export default Header;
